export default "__VITE_ASSET__P$$4CuUG__"